import { useEffect, useRef } from "react";
import { FormSpy } from "react-final-form";
import { AnalyticsType } from "~/services/analytics/types";

interface TrackerProps {
  fields: string[];
  analytics?: AnalyticsType;
  stepName: string;
  triggerOnce?: boolean;
  values: Record<string, any>;
}

const FormValueTrackerContent = ({
  fields,
  analytics,
  stepName,
  triggerOnce = true,
  values
}: TrackerProps) => {
  const triggeredRef = useRef(false);

  useEffect(() => {
    if (!values) return;
    if (triggerOnce && triggeredRef.current) return;

    const filledCount = fields.filter(name => {
      const v = values?.[name];
      return v !== null && v !== undefined && v !== "";
    }).length;

    if (filledCount >= 2) {
      analytics?.trackStep(stepName);
      if (triggerOnce) triggeredRef.current = true;
    }
  }, [values, fields, analytics, stepName, triggerOnce]);

  return null;
};

/**
 * Отслеживает заполнение указанных полей формы.
 * Как только любые 2 поля из списка становятся непустыми, вызывается analytics.trackStep(stepName)
 */
export const UseFormValueTracker = ({
  fields,
  analytics,
  stepName,
  triggerOnce = true
}: {
  fields: string[];
  analytics?: AnalyticsType;
  stepName: string;
  triggerOnce?: boolean;
}) => {
  return (
    <FormSpy subscription={{ values: true }}>
      {({ values }) => (
        <FormValueTrackerContent
          fields={fields}
          analytics={analytics}
          stepName={stepName}
          triggerOnce={triggerOnce}
          values={values}
        />
      )}
    </FormSpy>
  );
};
